'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M17 3H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H7V5h10v14z' });

var CropPortrait = function CropPortrait(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

CropPortrait = (0, _pure2.default)(CropPortrait);
CropPortrait.muiName = 'SvgIcon';

exports.default = CropPortrait;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/CropPortrait.js
// module id = 2295
// module chunks = 0